module.exports = __webpack_public_path__ + "static/media/gold-chips-medium.88189b8c.svg";